import React, {useState, useEffect} from 'react';

const MostrarNotificacionModal = ({notificacion}) => {

  useEffect(() => {
  }, []);

  return (
    <div className="modal fade" id="notificacionModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">{notificacion.asunto}</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div dangerouslySetInnerHTML={{__html: notificacion.mensaje}} />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MostrarNotificacionModal;